import { useIsHomeFeedAPIEnabled } from 'src/store/featureFlags/hooks';

import { useSignedInDashboardContext } from '../../SignedInDashboardContextProvider';
import { useCareerFeed } from '../../hooks/useCareerFeed';
import type { useHomeRecommendations } from '../../hooks/useHomeRecommendations';

export const useRecommendationForCareerFeedAiAssistant = (): Pick<
  ReturnType<typeof useHomeRecommendations>,
  'error' | 'loading' | 'isRefreshLoading' | 'refresh'
> & {
  jobIds: string[];
} => {
  const isFeedEnabled = useIsHomeFeedAPIEnabled();

  const { recommendationsResult } = useSignedInDashboardContext();
  const careerFeed = useCareerFeed();

  if (!isFeedEnabled) {
    return {
      ...recommendationsResult,
      jobIds:
        recommendationsResult.rawRecommendedJobs?.globalJobs.map(
          (job) => job.id,
        ) ?? [],
    };
  }

  return {
    isRefreshLoading: false,

    // TODO: Should use careerFeed.refresh() when ready
    refresh: async (_args) => ({
      success: false,
      error: new Error('Home feed API is disabled'),
    }),
    // This is a temporary solution to align with the RecsGraphQL to tell GenAI about is the Recs is empty or not
    jobIds:
      careerFeed.feedItems?.reduce<string[]>((acc, item) => {
        if (item.type === 'JOB') {
          acc.push(item.id);
        }
        return acc;
      }, []) ?? [],
    ...careerFeed,
  };
};
